/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceConfigurationExtendedItemDto } from "./DeviceConfigurationExtendedItemDto";
import {
    DeviceConfigurationExtendedItemDtoFromJSON,
    DeviceConfigurationExtendedItemDtoFromJSONTyped,
    DeviceConfigurationExtendedItemDtoToJSON,
} from "./DeviceConfigurationExtendedItemDto";

/**
 *
 * @export
 * @interface DeviceConfigurationExtendedDto
 */
export interface DeviceConfigurationExtendedDto {
    /**
     *
     * @type {Array<DeviceConfigurationExtendedItemDto>}
     * @memberof DeviceConfigurationExtendedDto
     */
    items?: Array<DeviceConfigurationExtendedItemDto>;
}

/**
 * Check if a given object implements the DeviceConfigurationExtendedDto interface.
 */
export function instanceOfDeviceConfigurationExtendedDto(
    value: object,
): value is DeviceConfigurationExtendedDto {
    return true;
}

export function DeviceConfigurationExtendedDtoFromJSON(
    json: any,
): DeviceConfigurationExtendedDto {
    return DeviceConfigurationExtendedDtoFromJSONTyped(json, false);
}

export function DeviceConfigurationExtendedDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConfigurationExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(
                      DeviceConfigurationExtendedItemDtoFromJSON,
                  ),
    };
}

export function DeviceConfigurationExtendedDtoToJSON(
    value?: DeviceConfigurationExtendedDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(
                      DeviceConfigurationExtendedItemDtoToJSON,
                  ),
    };
}
